<div class="app-sidebar border-right-1 border-color-primary" *ngIf="currentUser$ | async as user">
    <div class="brand" *appDesktop>
        <a id="logo" class="app-logo" [routerLink]="['/']">
            <picture>
                <!-- Imagen para tema claro o sin preferencia -->
                <source
                    srcset="assets/img/brand/rise-logo-long.svg"
                    media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)" />
                <!-- Imagen para tema oscuro -->
                <source
                    srcset="assets/img/brand/rise-dark-logo-long.svg"
                    media="(prefers-color-scheme: dark)" />
                <!-- Fallback general si no aplica ninguna de las media queries -->
                <img
                    class="menu-logo"
                    src="assets/img/brand/rise-logo-long.svg"
                    alt="App Logo" />
            </picture>
        </a>
        <!--Trial Badge-->
    </div>
    <nav class="leftnav justify-content-between">
        <ul class="settings">
            @for (item of (mainMenu$ | async)?.items; track item) {
                <li>
                    <ng-container *featureFlag="item?.feature">
                        <a
                            class="menu-item"
                            [class.disabled]="item.disabled"
                            [routerLink]="item.disabled ? null : item.routerLink"
                            [routerLinkActive]="item.disabled ? '' : 'active'"
                            [style.pointer-events]="item.disabled ? 'none' : 'auto'"
                            [style.opacity]="item.disabled ? '0.5' : '1'"
                            appFeatureHighlight
                            [feature]="item.highlight">
                            <div>
                                @if (item.icon) {
                                    <img
                                        class="menu-icon"
                                        [src]="item.icon"
                                        alt="icon" />
                                }
                                <div class="menu-text">
                                    <div
                                        class="menu-label"
                                        >{{ item.label }}</div
                                    >
                                    @if (item?.hasNotification$ | async) {
                                        <div class="notification"></div>
                                    }
                                    <app-feature-highlight-badge></app-feature-highlight-badge>
                                </div>
                            </div>
                        </a>
                    </ng-container>
                </li>
            }
            @if (formMenu$ | async; as formMenu) {
                @if (formMenu.items.length > 0) {
                    <li>
                        <a class="menu-item section-label">
                            <div>
                                <img
                                    class="menu-icon"
                                    [src]="formMenu.icon"
                                    alt="icon" />
                                <div class="menu-text">
                                    <div
                                        class="menu-label"
                                        >{{ formMenu.label }}</div
                                    >
                                    <span
                                        class="menu-icon accordion"
                                        (click)="toggleCollapse()">
                                        <app-custom-icon
                                            [iconPath]="'assets/icons/general-icons.svg'"
                                            [imageName]="showForms ? 'chevron-up' :  'chevron-down'">
                                        </app-custom-icon>
                                    </span>
                                </div>
                            </div>
                            @if ((isAtLeastAdmin$ | async) && !isAsap) {
                                <span
                                    class="menu-icon new-form"
                                    [routerLink]="['/assessments', 'new']"
                                    [routerLinkActive]="'new-form-active'">
                                    <app-custom-icon
                                        [iconPath]="'assets/icons/general-icons.svg'"
                                        [imageName]="'plus-small'">
                                    </app-custom-icon>
                                </span>
                            }
                        </a>
                    </li>
                    @if (showForms) {
                        <!--TODO: add animations-->
                        @for (item of formMenu.items; track item) {
                            <li>
                                <a
                                    class="menu-item"
                                    [routerLink]="item.routerLink"
                                    [routerLinkActive]="'active'"
                                    appFeatureHighlight
                                    [feature]="item.highlight"
                                    #link="routerLinkActive">
                                    <div>
                                        <app-list-icon
                                            [isActive]="link.isActive"></app-list-icon>
                                        <div class="menu-text">
                                            <div
                                                class="menu-label"
                                                >{{ item.label }}</div
                                            >
                                            <app-feature-highlight-badge></app-feature-highlight-badge>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        }
                    }
                }
            }
        </ul>
        <div class="flex flex-column">
            @if (hasNotDismissedBanner$ | async) {
                <div class="px-3">
                    <app-setup-guide-button
                        [hasNotDismissedBanner]="hasNotDismissedBanner$ | async"
                        [asapFormId$]="asapFormId$">
                    </app-setup-guide-button>
                </div>
            }

            @if (isAsap && (isOwner$ | async)) {
                <div class="my-3 px-3">
                    <app-promotional-banner
                        [show]="true"
                        [link]="['/profile/subscription']"
                        [canRedirect]="true"
                        title="Unlock the power of RISE"
                        subtitle="Compare available plans">
                    </app-promotional-banner>
                </div>
            }
            @if (!isAsap) {
                <app-trial-badge></app-trial-badge>
            }
        </div>
    </nav>

    <!--User Information-->
    <div
        class="user-card flex align-items-center justify-content-between cursor-pointer px-3 py-3 border-top-1 absolute bottom-0 w-full"
        [routerLink]="['/profile']"
        [routerLinkActive]="'active'">
        <div class="flex flex-column max-w-12rem ">
            <h6
                class="font-bold text-sm line-height-3 m-0 white-space-nowrap overflow-hidden text-overflow-ellipsis"
                >{{ user.firstName }} {{ user.lastName }}</h6
            >
            <p
                class=" text-xs line-height-3 m-0 white-space-nowrap overflow-hidden text-overflow-ellipsis"
                style="color: var(--text-read-only-color);"
                >{{ user.email }}</p
            >
        </div>
        <i
            class="pi pi-chevron-right"
            style="color: var(--text-read-only-color);"></i>
    </div>
</div>
